import T from "prop-types";

export default T.shape({
  id: T.number,
  nazev: T.string,
  datumVytvoreni: T.number,
  obsah: T.string,
  obrazek: T.shape({ name: T.string, saveDate: T.number, fullName: T.string }),
  popis: T.string,
  prilohy: T.arrayOf(
    T.shape({ name: T.string, saveDate: T.number, fullName: T.string })
  )
});
